<template>
  <v-container fluid pa-0 >
    <v-layout column>
      <v-flex mb-2>
        <v-layout row>
          <v-flex>
            <span class="headline">
              Segmentos Inteligentes
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex>
        <v-card>
          <v-card-text>
            <v-layout>
              <v-flex xs12>
                <template v-if="isSearching">
                  <skeleton-distribution ></skeleton-distribution>
                </template>
                <template v-else>
                  <distribution-graphic class="clickable" v-if="data.length > 0 && loadedCharts" :data="data" @show="show"></distribution-graphic>
                  <template v-else>
                    <v-layout row class="sizebox align-center">
                      <v-flex class="text-xs-center">
                        <span class="headline">
                          No hay información
                        </span>
                      </v-flex>
                    </v-layout>
                  </template>
                </template>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import DistributionGraphic from './DistributionGraphic';
import SkeletonDistribution from './SkeletonDistribution';

export default {
  props: {
    isSearching: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    DistributionGraphic,
    SkeletonDistribution,
  },
  mounted() {
    this.$store.dispatch('INITIALIZE_CHART');
  },
  computed: {
    ...mapGetters([
      'loadedCharts',
    ]),
  },
  methods: {
    graphicData() {
      _.each(this.data, (category) => {
        const percent = (category.quantity * 100) / 6;
        const checkLabel = (98 * percent) / 100;
        let html = '<div style="text-align: center;">';
        if ((checkLabel + 6) >= category.letter.length) {
          html += `<span style="font-size: 15px; font-weight: 500px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            {name}
          </span>
          <br />
          <span style="font-size: 15px; font-weight: 500px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
            Riesgo: {category}%
          </span>
          <br />
          <span style="font-size: 22px; font-weight: bolder;">
            {value} ({id}%)
          </span>`;
        } else {
          html += `<span style="font-size:  ${percent}; font-weight: bolder;">
            {value}
          </span>`;
        }
        html += '</div>';
        // eslint-disable-next-line
        category.label = html;
      });
    },
    show(name) {
      this.details = this.data.find(x => x.letter === name);
      this.$emit('segment', this.details);
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.graphicData();
      },
    },
  },
};
</script>
<style scoped>
.sizebox {
  height: 65vh;
}
.skeleton-line-custom {
  border-radius: 0 !important;
  height: 65vh;
}
</style>




// WEBPACK FOOTER //
// src/components/reports/segmentation/distribution/Index.vue